module.exports = __webpack_public_path__ + "img/insert-01-gauche.8b2db490.svg";